import React, { createContext, useReducer } from 'react';
import axios from '../../../../../../api/axios';

export const RulesContext = createContext(null);
const initialState = {
  inProgress: false,
  rule: {
    description: null,
    slug: null,
    routes: null,
  },
  rules: null,
  categories: null,
  page: 1,
  mode: 'add',
};
function reducer(state, actions) {
  const { payload, type } = actions;
  switch (type) {
    case 'PROGRESS':
      return { ...state, inProgress: payload };
    case 'CHANGE':
      return {
        ...state,
        rule: { ...state.rule, [payload.name]: payload.value },
      };
    case 'RULES':
      return { ...state, rules: payload };
    case 'CATEGORIES':
      return { ...state, categories: payload };
    case 'ADD_RULE':
      return {
        ...state,
        category: '',
        rules: { ...state.rules, docs: [payload, ...state.rules.docs] },
      };
    case 'RESET_FORM':
      return {
        ...state,
        rule: {
          description: null,
          slug: null,
          routes: null,
        },
        mode: 'add',
      };
    case 'RESET':
      return { ...initialState };
    case 'PAGE':
      return { ...state, page: payload };
    case 'SELECT_RULE':
      return {
        ...state,
        mode: 'edit',
        rule: {
          description: payload.description,
          slug: payload.slug,
          routes: payload.routes?.join(`\n`),
          _id: payload._id,
        },
      };
    case 'DELETE_RULE':
      return {
        ...state,
        rules: {
          ...state.rules,
          docs: state.rules.docs.filter((rule) => rule._id !== payload),
        },
      };
    default:
      return state;
  }
}

const RulesProvider = ({ children, showMessage, showError }) => {
  const [state, dispatch] = useReducer(reducer, initialState);

  const changeTextField = (e) => {
    const { name, value } = e.target;
    dispatch({ type: 'CHANGE', payload: { name, value } });
  };
  const loadCategories = async () => {
    try {
      dispatch({ type: 'PROGRESS', payload: true });
      const { data } = await axios.get(`/api/v1/admin/rules/categories/all`);
      data?.ok && dispatch({ type: 'CATEGORIES', payload: data.categories });
    } catch (error) {
      showError(error);
    }
    dispatch({ type: 'PROGRESS', payload: false });
  };
  const createRule = async ({ description, slug, routes, category }) => {
    try {
      routes = routes?.trim()?.split(/\s+/) || '';
      const { data } = await axios.post(`/api/v1/admin/rules`, {
        description,
        slug,
        routes,
        category,
      });
      data?.ok && showMessage(data.messages);
      if (state.rules === null) loadRules(category, state.page, 20);
      else {
        dispatch({ type: 'ADD_RULE', payload: data.rule });
        dispatch({ type: 'RESET_FORM' });
      }
    } catch (error) {
      showError(error);
    }
  };
  const editRule = async ({ description, slug, routes, category, _id }) => {
    try {
      routes = routes.trim().split(/\s+/);
      const { data } = await axios.put(`/api/v1/admin/rules/${_id}`, {
        description,
        slug,
        routes,
        category,
      });
      data?.ok && showMessage(data.messages);
      dispatch({ type: 'RESET_FORM' });
      loadRules(category, state.page, 20);
    } catch (error) {
      showError(error);
    }
  };
  const deleteRule = async (id) => {
    try {
      dispatch({ type: 'PROGRESS', payload: true });
      const { data } = await axios.delete(`/api/v1/admin/rules/${id}`);
      data?.ok && showMessage(data.messages);
      dispatch({ type: 'DELETE_RULE', payload: id });
      dispatch({ type: 'RESET_FORM' });
    } catch (error) {
      showError(error);
    }
    dispatch({ type: 'PROGRESS', payload: false });
  };
  const loadRules = async (category, page, limit) => {
    try {
      const { data } = await axios.post(`/api/v1/admin/rules/list`, {
        page,
        limit,
        category,
      });
      data?.ok && dispatch({ type: 'RULES', payload: data.rules });
    } catch (error) {
      showError(error);
    }
  };
  const changeRulesPage = (page) => {
    dispatch({ type: 'PAGE', payload: page });
  };
  const selectRule = (rule) => {
    dispatch({ type: 'SELECT_RULE', payload: rule });
  };
  const resetAll = () => {
    dispatch({ type: 'RESET' });
  };
  const resetForm = () => {
    dispatch({ type: 'RESET_FORM' });
  };

  return (
    <RulesContext.Provider
      value={{
        ...state,
        createRule,
        editRule,
        deleteRule,
        loadRules,
        loadCategories,
        changeTextField,
        changeRulesPage,
        selectRule,
        resetForm,
        resetAll,
        showMessage,
        showError,
      }}
    >
      {children}
    </RulesContext.Provider>
  );
};

export default React.memo(RulesProvider);
